import { HubtypePusherApp } from 'models/hubtype-pusher-app'

export interface InfrastructureState {
  readonly pusherApp: HubtypePusherApp
}

export const infrastructureInitialState: InfrastructureState = Object.freeze({
  pusherApp: null,
})
